import React from 'react';
import enhance from './ReviewProposals.enhancer';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import AllProposals from './AllProposals';
import Shortlisted from './Shortlisted';
import PendingEscrow from './PendingEscrow';
import { dealStatuses } from '../../../constants';
import ViewProposal from '../../../components/deals/proposals/ViewProposal';
import SwipeableViews from 'react-swipeable-views';
import { virtualize, bindKeyboard } from 'react-swipeable-views-utils';
import DealForm from '../../deals/new-deal/DealForm';
import EscrowFunds from '../../deals/escrow-funds/EscrowFunds';

const VirtualizeSwipeableViews = bindKeyboard(virtualize(SwipeableViews));

class ReviewProposals extends React.Component {
  constructor() {
    super();

    this.initialState = {
      allProposedDeals: [],
      shortlisted: [],
      messaged: [],
      pendingEscrow: [],
      loadingUserData: false,
      currentDealProposal: {},
      viewPropsalIsOpen: false,
      index: 0
    };

    this.state = {
      ...this.initialState
    };
  }

  isAllProposalsSelected = page => {
    return page === 3;
  };

  isShortlistedSelected = page => {
    return page === 4;
  };

  isMessagedSelected = page => {
    return page === 5;
  };

  isPendingEscrowSelected = page => {
    return page === 6;
  };

  navigateToAllProposals() {
    this.props.history.push(`/campaigns/${this.props.campaign.id}/proposals`);
  }

  navigateToShortlisted() {
    this.props.history.push(`/campaigns/${this.props.campaign.id}/shortlisted`);
  }

  navigateToMessaged() {
    this.props.history.push(`/campaigns/${this.props.campaign.id}/messaged`);
  }

  navigateToPendingEscrow() {
    this.props.history.push(
      `/campaigns/${this.props.campaign.id}/pendingEscrow`
    );
  }

  openViewProposal(deal) {
    this.setState({
      currentDealProposal: deal,
      viewPropsalIsOpen: true,
      dealRecipient: deal.influencerId
    });
  }

  closeViewProposal() {
    this.setState({
      currentDealProposal: {},
      viewPropsalIsOpen: false
    });
  }

  proposeDealClick(deal) {
    this.setState({
      currentDeal: deal,
      dealRecipient: deal.user
    });
    this.handleNextClick();
  }

  handleNextClick() {
    const newIndex = this.state.index + 1;
    this.setState({
      index: newIndex
    });
  }

  handleBackClick() {
    const newIndex = this.state.index - 1;
    this.setState({
      index: newIndex
    });
  }

  handleBackToListClick() {
    this.setState({
      index: 0
    });
  }

  dealAcceptComplete(deal) {
    if (!deal.currentProposal.productOnly) {
      this.props.viewEscrowFundsClick(deal);
    }
  }

  getStepContent(params) {
    const { key } = params;
    switch (this.state.index) {
      case 0:
        return (
          <Paper className={this.props.classes.layout}>
            <div className={this.props.classes.proposalHeaderContainer}>
              <div
                className={`${this.props.classes.proposalHeader} ${
                  this.isAllProposalsSelected(this.props.page)
                    ? this.props.classes.proposalHeaderSelected
                    : ''
                }`}
                onClick={() => this.navigateToAllProposals()}
              >
                All Proposals{' '}
                {this.props.allProposals && this.props.allProposals.length > 0
                  ? `(${this.props.allProposals.length})`
                  : ''}
              </div>
              <div
                className={`${this.props.classes.proposalHeader} ${
                  this.isShortlistedSelected(this.props.page)
                    ? this.props.classes.proposalHeaderSelected
                    : ''
                }`}
                onClick={() => this.navigateToShortlisted()}
              >
                Shortlisted{' '}
                {this.props.shortlisted && this.props.shortlisted.length > 0
                  ? `(${this.props.shortlisted.length})`
                  : ''}
              </div>
              {/* <div
                className={`${this.props.classes.proposalHeader} ${
                  this.isMessagedSelected(this.props.page)
                    ? this.props.classes.proposalHeaderSelected
                    : ''
                }`}
                onClick={() => this.navigateToMessaged()}
              >
                Messaged{' '}
                {this.props.messaged && this.props.messaged.length > 0
                  ? `(${this.props.messaged.length})`
                  : ''}
              </div> */}
              <div
                className={`${this.props.classes.proposalHeader} ${
                  this.isPendingEscrowSelected(this.props.page)
                    ? this.props.classes.proposalHeaderSelected
                    : ''
                }`}
                onClick={() => this.navigateToPendingEscrow()}
              >
                Pending Escrow{' '}
                {this.props.pendingEscrow && this.props.pendingEscrow.length > 0
                  ? `(${this.props.pendingEscrow.length})`
                  : ''}
              </div>
            </div>
            <Divider />
            <div className={this.props.classes.reviewProposalsContentContainer}>
              {this.props.page === 3 && (
                <AllProposals
                  campaign={this.props.campaign}
                  allProposals={this.props.allProposals}
                  openViewProposal={this.openViewProposal.bind(this)}
                />
              )}
              {this.props.page === 4 && (
                <Shortlisted
                  campaign={this.props.campaign}
                  shortlisted={this.props.shortlisted}
                  openViewProposal={this.openViewProposal.bind(this)}
                />
              )}
              {this.props.page === 6 && (
                <PendingEscrow
                  campaign={this.props.campaign}
                  pendingEscrow={this.props.pendingEscrow}
                />
              )}
            </div>
          </Paper>
        );
      case 1:
        return (
          <DealForm
            key={key}
            handleBackClick={this.handleBackClick.bind(this)}
            handleBackToListClick={this.handleBackToListClick.bind(this)}
            currentDeal={this.state.currentDeal}
            dealRecipient={this.state.dealRecipient}
            user={this.props.auth}
            onProposalComplete={this.handleBackToListClick}
            shouldRedirect={false}
          />
        );
    }
  }

  render() {
    const {
      classes,
      page,
      allProposals,
      shortlisted,
      messaged,
      pendingEscrow
    } = this.props;
    const { currentDealProposal, viewPropsalIsOpen } = this.state;

    return (
      <React.Fragment>
        <VirtualizeSwipeableViews
          style={{ width: '100%' }}
          slideCount={2}
          index={this.state.index}
          slideRenderer={this.getStepContent.bind(this)}
          disabled={true}
        />
        <ViewProposal
          deal={currentDealProposal}
          handleProposeDeal={this.proposeDealClick.bind(this)}
          open={viewPropsalIsOpen}
          closeClick={this.closeViewProposal.bind(this)}
          onDealAcceptComplete={this.dealAcceptComplete.bind(this)}
          showButtons={true}
        />
        <EscrowFunds />
      </React.Fragment>
    );
  }
}

export default enhance(ReviewProposals);



// WEBPACK FOOTER //
// ./src/components/campaign/review-campaigns/ReviewProposals.js